import { InMemoryCache, ApolloLink, CombinedGraphQLErrors, CombinedProtocolErrors } from '@apollo/client/core';
import { ErrorLink } from '@apollo/client/link/error';
import { HttpLink } from 'apollo-angular/http';
import { SetContextLink } from '@apollo/client/link/context';
import { RetryLink } from '@apollo/client/link/retry';
import { environment } from 'environments/environment';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export function apolloInitializer2() {

  const keycloakInstance = inject(Keycloak);
  const token = keycloakInstance.token;

  const httpLink = inject(HttpLink);
  const authLink = new SetContextLink((prevContext, operation) => ({credentials: "include",}));

  const retryLink = new RetryLink({
    attempts: {
      max: 10,
      retryIf: (error) => !!error,
    },
    delay: {
      initial: 30000,
      max: 30000,
      jitter: false,
    },
  });

  const errorLink = new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) =>
        console.error(`[GraphQL error APIv2]: Message: "${message}", Operation: ${operation}, Path: ${path}, Locations: ${locations}`),
      );
    } else if (CombinedProtocolErrors.is(error)) {
      error.errors.forEach(({ message, extensions }) =>
        console.error(`[GraphQL error APIv2]: Message: "${message}", Extensions: ${JSON.stringify(extensions)}`),
      );
    } else {
      console.error(`[Network error APIv2]: ${error.name}`);
    }
  });

  // HTTP Connection
  const http = httpLink.create({ uri: environment.graphql_http2 });
  const httpOptions = {
    link: ApolloLink.from([errorLink, retryLink, authLink.concat(http)]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
    },
  }

  // WebSocket Connection
  const webSocket = new GraphQLWsLink(createClient({
    url: environment.graphql_ws2,
    connectionParams: {
      authToken: `Bearer ${token}`,
    }
  }));
  const webSocketOptions = {
    link: ApolloLink.from([errorLink, webSocket]),
    cache: new InMemoryCache({
      typePolicies: {
        PORTFOLIO: {
          fields: {
            DATA: {
              merge: false
            },
            PARKS: {
              merge: false
            },
          },
        },
        COUNTRY: {
          fields: {
            PARKS: {
              merge: false
            },
          },
        },
        TURBINE: {
          fields: {
            DATA: {
              merge: false
            },
          },
        },
      }
    })
  }

  return {
    'v2_http': httpOptions,
    'v2_ws': webSocketOptions
  }
}